import { Grid } from "antd";

const { useBreakpoint } = Grid;
const Background = ({ alternative }:{ alternative: boolean }) => {
  const { xl } = useBreakpoint();

  return (
    <div style={{
      position: "absolute",
      height: "100%",
      width: "100%",
      left: 0,
      top: 0,
      pointerEvents: "none",
      overflow: "hidden"
    }}
    >

      {xl ? (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 854 732"
            fill="none"
            className={`absolute -top-[10%] right-0 w-[50%] z-[1]${alternative ? " opacity-30" : ""}`}
          >
            <path d="M854 0H0C24.8236 82.4761 115.15 307.835 358.319 293.663C655.566 276.343 793.315 380.258 778.816 524.581C770.156 610.801 815.819 685.676 854 732V0Z" fill="url(#paint0_linear_2333_21445)"/>
            <defs>
              <linearGradient id="paint0_linear_2333_21445" x1="252.363" y1="466.906" x2="905.864" y2="89.9092" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00327F"/>
                <stop offset="1" stopColor="#00103F"/>
              </linearGradient>
            </defs>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 594 252"
            fill="none"
            className={`absolute top-0 right-0 z-[2] h-[31%]${alternative ? " opacity-30" : ""}`}
          >
            <path d="M594.001 0H0.701172C58.2038 115.267 156.165 229.457 316.859 217.432C431.36 208.864 523.616 222.013 594.001 251.62V0Z" fill="url(#paint0_linear_2333_21447)"/>
            <defs>
              <linearGradient id="paint0_linear_2333_21447" x1="130.536" y1="29.7553" x2="818.82" y2="214.357" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00327F"/>
                <stop offset="1" stopColor="#00103F"/>
              </linearGradient>
            </defs>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 720 511"
            fill="none"
            className="bottom-0 right-0 absolute w-[50vw]"
          >
            <path d="M720 512V0C720 0 417.655 38.7576 433.026 206.021C448.398 373.284 356.156 450.799 228.044 442.642C99.9314 434.485 0 511.994 0 511.994H720V512Z" fill="#F2F3F6"/>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 823 420"
            fill="none"
            className="-top-[20%] left-0 absolute w-[70%]"
          >
            <path d="M0 420V0H618.683C615.013 23.2224 626.975 46.3318 676.663 59.2271C802.253 91.8371 853.517 183.561 804.817 265.089C756.117 346.617 586.954 344.584 540.818 250.82C494.681 157.063 351.144 59.2271 235.809 112.218C120.469 165.214 217.869 356.807 0.00594847 419.994L0 420Z" fill="#F2F3F6"/>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 361 312"
            fill="none"
            className="bottom-0 left-0 absolute h-[33%]"
          >
            <path d="M358.895 313C360.285 301.747 361 290.286 361 278.659C361 124.758 235.799 0 81.3525 0C53.0544 0 25.7461 4.19466 0 11.9779V313H358.895Z" fill="url(#paint0_linear_2333_21446)"/>
            <defs>
              <linearGradient id="paint0_linear_2333_21446" x1="0" y1="156.503" x2="361" y2="156.503" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00327F"/>
                <stop offset="1" stopColor="#00103F"/>
              </linearGradient>
            </defs>
          </svg>
        </>
      ) : (
        <>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 466"
            fill="none"
            className="absolute top-0 right-0 w-[50%]"
          >
            <path d="M332.147 1.60326e-05L0.769511 3.05176e-05C0.769511 3.05176e-05 25.8543 195.685 134.111 185.736C242.367 175.787 292.537 235.488 287.257 318.405C281.978 401.322 332.143 466 332.143 466L332.143 1.60328e-05L332.147 1.60326e-05Z" fill="#F2F3F6"/>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 127 232"
            fill="none"
            className="absolute bottom-0 right-0 w-[23%]"
          >
            <path d="M203.147 1.36248C195.864 0.463325 188.446 0.000251187 180.92 0.000251516C81.3125 0.00025587 0.5664 81.0329 0.566404 180.994C0.566405 199.309 3.28128 216.984 8.31878 233.647L203.147 233.647L203.147 1.36248Z" fill="url(#paint0_linear_2305_17751)"/>
            <defs>
              <linearGradient id="paint0_linear_2305_17751" x1="101.859" y1="233.647" x2="101.859" y2="0.000239713" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00327F"/>
                <stop offset="1" stopColor="#00103F"/>
              </linearGradient>
            </defs>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 47 152"
            fill="none"
            className="absolute bottom-0 right-0 w-[9%] z-[1]"
          >
            <path d="M123.795 0.706644C54.2907 9.22899 0.470699 68.3397 0.470703 139.996C0.470703 144.603 0.694039 149.156 1.12919 153.647L123.795 153.647L123.795 0.706644Z" fill="url(#paint0_linear_2305_17752)"/>
            <defs>
              <linearGradient id="paint0_linear_2305_17752" x1="62.1311" y1="153.647" x2="62.1311" y2="0.706647" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00327F"/>
                <stop offset="1" stopColor="#00103F"/>
              </linearGradient>
            </defs>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 195 531"
            fill="none"
            className="absolute bottom-0 left-0 z-[1] w-[35%] max-w-[160px]"
          >
            <path d="M194.833 532.664L-77 532.664L-77 132.239C-61.97 134.614 -47.0131 126.872 -38.6669 94.7128C-17.561 13.4281 41.8049 -19.7511 94.5716 11.7687C147.338 43.2886 146.022 152.774 85.3366 182.635C24.6547 212.495 -38.6669 305.396 -4.37028 380.043C29.9302 454.694 153.934 391.654 194.829 532.66L194.833 532.664Z" fill="#F2F3F6"/>
          </svg>
        </>
      )}
    </div>
  );
};

export default Background;
